module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Carla Cassidy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Carla Cassidy is a "), _c('I', [_vm._v("New York Times ")]), _vm._v("bestselling author who has written more than 125 novels for Harlequin Books.  She is listed on the Romance Writer's of America Honor Roll and has won numerous awards. Carla believes the only thing better than curling up with a good book to read is sitting down at the computer with a good story to write.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1A7JFU3/tc-custom/9781460310441.jpg?1720035147258",
      "alt": "This image is the cover for the book Scene of the Crime: Deadman's Bluff"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Scene of the Crime: Deadman's Bluff\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('i', [_vm._v("Buried Alive")]), _c('br'), _c('br'), _vm._v("FBI agent Seth Hawkins was on a mission to catch a serial killer. Yet his only leada mysterious azure-eyed beauty found buried alive in the local sand duneshad no memory of how she'd been abducted. Or anything else about her identity."), _c('br'), _c('br'), _vm._v("The only thing Tamara Jennings knew for sure was the  undeniable attraction she felt for the strong, handsome man  who saved her life. It wasn't long before their passion flared  out of control. But as memories of her forgotten past returned, would they lead her to the killerand to a life she could  share with Seth?"), _c('br'), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0